import { connect } from 'react-redux';
import { BoundEnabledPerspective, BoundTab } from 'configuration-schemas/bindings.types';
import { setFocusedGroup, setCollapsed } from './SideNav.slice';
import { SideNav } from 'src/components/Sidenav/Sidenav';
import { makePrintSensitive } from 'src/components/higherOrder/Print/PrintSenstive';
import { PrintProps } from 'src/components/higherOrder/Print/Print';
import type { AppThunkDispatch } from 'src/store.types';
import type { AppState } from 'src/reducers';
import { WithRouterProps } from 'src/components/higherOrder/withRouter';
import { AxiosInstance } from 'axios';
import { deleteFavorite, loadFavorites, moveFavorite } from 'src/state/favorites/favorites.slice';
import { FavoritesEntry } from 'src/services/Favorites';
import { getScopeId, getScopeReadyData } from 'src/state/scope/Scope.types';
import { getMfpModule, shouldActiveTabShowBookmarks } from 'src/pages/NavigationShell/navigationUtils';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface SideNavOwnProps extends Pick<WithRouterProps, 'routerLocation'> {
  className: string;
  sectionName: string;
  perspective: BoundEnabledPerspective;
  tab: BoundTab;
}

export interface StateProps extends SideNavOwnProps {
  groupId: string | null;
  collapsed?: boolean;
  mfpFavorites: FavoritesEntry[];
  mfpScopeId?: string;
  showBookmarks: boolean;
  onlyIndirectMfpScoping: boolean;
  mfpScopeReady: boolean;
}

export interface DispatchProps {
  setFocusedGroup(groupId: string | null): void;
  setCollapsed(collapsed?: boolean): void;
  loadFavorites?: (axios: AxiosInstance) => void;
  removeFavorite?: (axios: AxiosInstance, key: string) => Promise<void> | undefined;
  moveFavorite?: (axios: AxiosInstance, key: string, direction: 'up' | 'down') => Promise<void> | undefined;
}

export interface Props extends StateProps, DispatchProps, PrintProps, WithTranslation {}

function stateToProps(state: AppState, ownProps: SideNavOwnProps): StateProps {
  const mfpScopeId = getScopeId(state.mfpScope);
  const mfpScopeReadyStatus = !!getScopeReadyData(state.mfpScope);
  const onlyIndirectMfpScoping = !!getMfpModule(state)?.onlyIndirectMfpScoping;
  const showBookmarks = shouldActiveTabShowBookmarks(state);

  return {
    ...ownProps,
    groupId: state.sidenav.groupId,
    collapsed: state.sidenav.collapsed,
    mfpFavorites: state.favorites.favorites,
    mfpScopeId: mfpScopeId || '',
    mfpScopeReady: mfpScopeReadyStatus,
    onlyIndirectMfpScoping: onlyIndirectMfpScoping,
    showBookmarks,
  };
}

function dispatchToProps(dispatch: AppThunkDispatch): DispatchProps {
  return {
    setFocusedGroup(groupId: string) {
      return dispatch(setFocusedGroup(groupId));
    },
    setCollapsed(collapsed: boolean) {
      return dispatch(setCollapsed(collapsed));
    },
    loadFavorites(axios: AxiosInstance) {
      return dispatch(loadFavorites(axios));
    },
    removeFavorite: (axios: AxiosInstance, key) => dispatch(deleteFavorite(axios, key)),
    moveFavorite: (axios: AxiosInstance, key: string, direction: 'up' | 'down') =>
      dispatch(moveFavorite(axios, key, direction)),
  };
}

const sensitiveView = withTranslation()(makePrintSensitive(SideNav));
export default connect(stateToProps, dispatchToProps)(sensitiveView);
